import { KYMW1400KomaPageModel } from '../kymw1400-koma-page/kymw1400-koma-page.model';
import { PageIDModel } from '../vo/page-id.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * ページ情報を取得する
 *
 * @export
 * @class GetPageService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetPageService extends PlessJsonResponderSub<any> {

  /** 処理に使用するModel */
  private model: KYMW1400KomaPageModel = null;
  private vo: PageIDModel = null;
  private successFunction: Function = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetPageService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        PageID: this.vo.pageID,
        MediumType: this.vo.mediumType
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW1400KomaPageModel} model モデルクラス
   * @param {PageIDModel} vo パラメータ
   * @param {Function} successFunction 成功時後続処理
   * @memberof GetPageService
   */
  execute(model: KYMW1400KomaPageModel, vo: PageIDModel, successFunction: Function) {
    this.model = model;
    this.vo = vo;
    this.successFunction = successFunction;
    this.send('KYMW14getPage', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPageService
   */
  success(data: any) {
    // 結果データの編集
    this.model.updatePage(data);

    // 計画値集計表取得
    if (this.successFunction != null) {
      this.successFunction();
    }
  }
}
